import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Menu, MenuItem } from "@mui/material";
import "./dataMapTable.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModalProcessor from "../../Modal/RejectModal/ModalProcessor";

const CellMenu = forwardRef((props, ref) => {
  const {
    rejectCell,
    isRejectedByProcessor,
    deleteRejection,
    role,
    markAsResolveByProcessor,
    isRejectedByValidator,
    validatorRejectionRemark,
    processorRejectionRemark,
    isRwoValidated,
    markAsResolveRejection,
    heading,
    isResolvedProcessorCellRejection,
    isResolvedValidatorCellRejection,
    parameter_question,
    updateParameterQuestion, // Add a new callback for saving updated parameter_question
    handleChangeReProcess,
    reInitiateProVlm,
    processorsRejectionCounts,
    reProcessVlmCounts,
    showMenuButton,
    handleDeleteModal,
    isShowDeleteButton,
    onlyShowParameterQuestion,
    indexOfParameter,
    updateMappingsInPro,
    resetCoordinates,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [editQuestionDialogOpen, setEditQuestionDialogOpen] = useState(false); // New state
  const [content, setContent] = useState("");
  const [disableFooterBtns, setDisableFooterBtns] = useState(false);
  const [editableQuestion, setEditableQuestion] = useState(parameter_question); // State for the editable question
  const openpop = Boolean(anchorEl);

  useImperativeHandle(ref, () => ({
    openParameterQuestionModal: (context) => {
      setEditableQuestion(context);
      setEditQuestionDialogOpen(true);
    },
  }));

  useEffect(() => {
    setEditableQuestion(parameter_question);
  }, [parameter_question]);

  const options = (
    isRejectedByProcessor,
    isRejectedByValidator,
    isResolvedProcessorCellRejection,
    isResolvedValidatorCellRejection,
  ) => {
    if (onlyShowParameterQuestion) {
      return ["Parameter Question"];
    }

    let options = [];
    if (role === "preProcessor") {
      if (isRejectedByProcessor) {
        options = ["View Remark & Resolve", "Parameter Question"];
      } else {
        options = ["Parameter Question"];
      }
    } else if (role === "processor") {
      if (reProcessVlmCounts === 0) {
        options = ["Reject"];
      }

      if (processorsRejectionCounts === 0) {
        options.push("Re-Process");
      }

      if (isRejectedByProcessor) {
        options = ["Undo Rejection"];
      }
      if (isRejectedByValidator) {
        options = [...options, "View Validator Remark & Resolve"];
      }
      if (isResolvedProcessorCellRejection) {
        options = ["Reject", "Re-Process", "View Remark"];
      }

      if (isRejectedByValidator && isResolvedProcessorCellRejection) {
        options = ["Reject", "View Remark", "View Validator Remark & Resolve"];
      }

      if (reInitiateProVlm) {
        options = options.filter((option) => option !== "Re-Process"); // Remove "Re-Process"
        options.push("Undo Re-Process"); // Add "Undo Re-Process"
      }

      options.push("Parameter Question");
      options.push("Update Mappings");
      options.push("Reset Coordinates");
    } else if (role === "validator") {
      options = ["Reject"];

      if (isResolvedValidatorCellRejection) {
        options = ["Reject", "View Remark"];
      }

      if (isRejectedByValidator) {
        options = ["Undo Rejection"];
      }
      options.push("Parameter Question");
    }

    return options;
  };

  const handleClickOption = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopUp = () => {
    setAnchorEl(null);
  };

  const handleClickOnOption = (option) => {
    if (role === "preProcessor") {
      if (option === "View Remark & Resolve") {
        setContent(processorRejectionRemark);
        setViewDialogOpen(true);
      } else if (option === "Parameter Question") {
        setEditableQuestion(parameter_question);
        setEditQuestionDialogOpen(true); // Open the dialog for editing
      }
    }

    if (role === "processor") {
      if (option === "Reject") {
        setContent("");
        setModalOpen(true);
      }
      if (option === "Edit") {
        setContent(processorRejectionRemark);
        setModalOpen(true);
      }
      if (option === "Undo Rejection") {
        setContent("");
        handleDeleteRejection();
      }
      if (option === "View Validator Remark & Resolve") {
        setContent(validatorRejectionRemark);
        setViewDialogOpen(true);
        setDisableFooterBtns(false);
      }
      if (option === "Mark As Resolve") {
        markAsResolveByProcessor();
      }
      if (option === "View Remark") {
        setDisableFooterBtns(true);
        setContent(processorRejectionRemark);
        setViewDialogOpen(true);
      }
      if (option === "Re-Process") {
        handleChangeReProcess("addToReProcess");
      }
      if (option === "Undo Re-Process") {
        handleChangeReProcess("remmoveFromReProcess");
      }
      if (option === "Reset Coordinates") {
        resetCoordinates();
      }

      if (option === "Parameter Question") {
        setEditableQuestion(parameter_question);
        setEditQuestionDialogOpen(true); // Open the dialog for editing
      }
      if (option === "Update Mappings") {
        updateMappingsInPro();
      }
    }

    if (role === "validator") {
      if (option === "Reject") {
        setModalOpen(true);
      }
      if (option === "Edit") {
        setContent(validatorRejectionRemark);
        setModalOpen(true);
      }
      if (option === "Undo Rejection") {
        setContent("");
        handleDeleteRejection();
      }
      if (option === "View Remark") {
        setDisableFooterBtns(true);
        setContent(validatorRejectionRemark);
        setViewDialogOpen(true);
      }
      if (option === "Parameter Question") {
        setEditableQuestion(parameter_question);
        setEditQuestionDialogOpen(true); // Open the dialog for editing
      }
    }
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setModalOpen(false);
  };

  const handleReject = (rejectionRemark) => {
    rejectCell(rejectionRemark);
    setAnchorEl(null);
    setModalOpen(false);
  };

  const handleCloseViewDialogBox = () => {
    setViewDialogOpen(false);
    setAnchorEl(null);
  };

  const markAsResolveViewDialogBox = () => {
    markAsResolveByProcessor();
    setViewDialogOpen(false);
  };

  const handleDeleteRejection = () => {
    deleteRejection();
    setAnchorEl(null);
    setModalOpen(false);
  };

  const markAsResolve = () => {
    markAsResolveRejection();
    setModalOpen(false);
  };

  const disableDeleteRejection = () => {
    // if the cell is rejected then only enable delete button
    if (role === "processor") {
      return isRejectedByProcessor ? false : true;
    } else if (role === "validator") {
      return isRejectedByValidator ? false : true;
    }
  };

  const disableMarkAsResolve = () => {
    if (role === "preProcessor") {
      return isRejectedByValidator ? false : true;
    }
  };

  const isDisabled = () => {
    let disable = false;
    if (role === "validator" && isRwoValidated) {
      disable = true;
    }
    return disable;
  };
  const handleSaveQuestion = (question) => {
    updateParameterQuestion(question); // Save the updated question
    setEditQuestionDialogOpen(false);
  };

  const handleDelete = () => {
    handleDeleteModal();
    setEditQuestionDialogOpen(false);
  };

  return (
    <>
      {showMenuButton && (
        <button
          aria-label="more"
          aria-controls="long-menu"
          id="long-button"
          className="readMore-btn"
          aria-haspopup="true"
          onClick={handleClickOption}
        >
          <MoreVertIcon />
        </button>
      )}
      {openpop && (
        <Menu
          id="basic-menu"
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          anchorEl={anchorEl}
          onClose={handleClosePopUp}
          open={openpop}
        >
          {options(
            isRejectedByProcessor,
            isRejectedByValidator,
            isResolvedProcessorCellRejection,
            isResolvedValidatorCellRejection,
          ).map((option) => (
            <MenuItem
              key={option}
              onClick={() => {
                handleClickOnOption(option);
              }}
              disabled={isDisabled()}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      )}
      {modalOpen && (
        <ModalProcessor
          modalOpen={modalOpen}
          handleClose={handleClose}
          handleReject={handleReject}
          isShowClearButton={false}
          rejectionContent={content}
          handleDeleteRejection={handleDeleteRejection}
          disableDeleteRejection={disableDeleteRejection()}
          disableMarkAsResolve={disableMarkAsResolve()}
          markAsResolve={markAsResolve}
          heading={heading}
        />
      )}

      {viewDialogOpen && (
        <ModalProcessor
          modalOpen={viewDialogOpen}
          handleClose={handleCloseViewDialogBox}
          rejectionContent={content}
          heading={"Cell Rejection Remark."}
          isReadOnly={true}
          markAsResolve={markAsResolveViewDialogBox}
          disableFooterBtns={disableFooterBtns}
        />
      )}

      {editQuestionDialogOpen && (
        <ModalProcessor
          modalOpen={editQuestionDialogOpen}
          handleClose={() => setEditQuestionDialogOpen(false)}
          heading={"Parameter Question"}
          rejectionContent={editableQuestion}
          handleReject={(question) =>
            handleSaveQuestion(question, indexOfParameter)
          }
          rows={4}
          isReadOnly={role === "validator" ? true : false}
          disableFooterBtns={role === "validator" ? true : false}
          hideFooterBtns={role === "validator" ? true : false}
          isShowDeleteButton={isShowDeleteButton}
          handleDelete={handleDelete}
        ></ModalProcessor>
      )}
    </>
  );
});

CellMenu.defaultProps = {
  showMenuButton: true,
  onlyShowParameterQuestion: false,
};

export default CellMenu;
